<template>
  <div>
    <v-card flat>
      <v-row no-gutters>
        <v-col cols="3" class="pt-0 mb-2">
          <v-select
            :items="languages"
            :value="language"
            :label="$t('globals.language')"
            @change="(v) => $emit('update:language', v)"
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="8" class="pt-0 mb-2 ml-10">
          <no-autocomplete-textfield
            :value.sync="innerSubject"
            :label="$t('components.emaildialog.subject')"
          />
        </v-col>
      </v-row>
      <Editor
        v-model="editorData"
        :api-key="settings.HtmlEditorApiKey"
        :initial-value="editorData"
        :init="{
          height: 800,
          paste_data_images: true,
          images_upload_handler: imagesUploadHandler,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount',
          ],
          toolbar:
            'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
        }"
      />
    </v-card>
    <!-- <file-uploads-list /> -->
    <v-form ref="form" v-model="valid" class="pa-4 pb-0">
      <v-row justify="center">
        <v-col cols="12" class="pa-0">
          <h3>
            {{ $t("views.welcomekit.test_data") }}
          </h3>
        </v-col>
        <v-col cols="12">
          <v-btn @click="addKeyValue">Add Key/Value</v-btn>
        </v-col>
        <v-col cols="12">
          <v-row
            v-for="(kv, i) in internalKeyValuePairs"
            :key="'kv' + i"
            class="mx-sm-12"
          >
            <v-col cols="5" class="pa-2">
              <v-text-field
                clearable
                :label="$t('views.welcomekit.key')"
                placeholder="{key}"
                v-model="kv.Key"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-text-field
                clearable
                :label="$t('globals.value')"
                placeholder="value"
                v-model="kv.Value"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col align-self="center">
              <v-btn class="remove-btn" icon @click="removeKeyValue(i)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            outlined
            dense
            v-model="email"
            :label="$t('views.welcomekit.email')"
            :rules="[$rules.required, $rules.email]"
          ></v-text-field>
        </v-col>
        <v-col class="mt-1 py-0">
          <v-btn :loading="sending" :disabled="!valid" @click="send">
            {{ $t("views.welcomekit.send_test_email") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-row no-gutters>
      <h3 class="text-left mb-4">{{ $t("globals.preview") }}</h3>
      <div v-html="editorData" class="mt-4"></div>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import NoAutocompleteTextfield from "./NoAutocompleteTextfield.vue";
export default {
  components: {
    Editor,
    NoAutocompleteTextfield
  },
  expose: ["editorData", "internalKeyValuePairs"],
  props: {
    html: String,
    keyValuePairs: Array,
    plan: String,
    language: String,
    subject: String
  },
  data() {
    return {
      languages: ["en", "fr"],
      sending: false,
      email: "",
      valid: false,
      editorData: this.html,
      internalKeyValuePairs: [],
      innerSubject: null
    };
  },
  computed: {
    ...mapGetters("auth", ["user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    innerSubject: {
      handler(v) {
        this.$emit("update:subject", v);
      },
    },
  },
  mounted() {
    this.internalKeyValuePairs = this.keyValuePairs;
    this.editorData = this.html;
    this.innerSubject = this.subject;
  },
  methods: {
    ...mapActions("downloadCenter", ["sendTestWelcomeKit"]),
    addKeyValue() {
      if (!this.internalKeyValuePairs) {
        this.internalKeyValuePairs = [];
      }
      this.internalKeyValuePairs.push({
        Key: "",
        Value: "",
      });
    },
    removeKeyValue(i) {
      this.internalKeyValuePairs.splice(i, 1);
    },
    imagesUploadHandler(blobInfo, success, failure) {
      // no upload, just return the blobInfo.blob() as base64 data
      success("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
    },
    async send() {
      this.sending = true;
      try {
        await this.sendTestWelcomeKit({
          planIdentityId: this.plan,
          payload: {
            Html: this.editorData,
            Email: this.email,
            KeyValues: this.keyValuePairs,
            Subject: this.subject || "Test Welcome Kit"
          },
        });
        this.message = {};
        this.snackbar = true;
        // this.$refs.form.reset();
        this.$refs.form.resetValidation();
      } catch (error) {
        console.log(error);
        if (error.customMessage === null || error.customMessage === undefined) {
          this.error = {
            customMessage: this.$t("globals.failed"),
          };
        } else {
          this.error = error;
        }
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
<style scoped>
.remove-btn >>> .v-btn__content .v-icon {
  margin-right: 0 !important;
}
</style>
